export const buildBoilerMatrixExportRows = (matrix = []) => matrix.map((line) => ({
  'Inspection Area': line.groupName || '',
  'Subgroup': line.subgroup || '',
  'Matrix Line': line.item || '',
  'Inspection Methods': (line.methods || []).join(', '),
  'Inspection Description': line.inspectionDescription || '',
  'Frequency': line.frequency || '',
  'Inspection Interval (Years)': line.inspectionIntervalYears ?? '',
  'Last Inspection': line.notApplicable ? 'N/A' : line.lastInspectionDate || '',
  'Next Inspection': line.notApplicable
    ? 'N/A'
    : line.nextInspectionDue || (line.inspectionIntervalYears ? 'Awaiting inspection date' : 'Interval not set'),
  'Notes': line.notes || '',
}));

export const formatActionItemDate = (dateValue) => {
  if (!dateValue) return '-';
  const date = new Date(dateValue);
  return Number.isNaN(date.getTime()) ? '-' : date.toISOString().split('T')[0];
};

export const buildActionItemPdfRows = (items = []) => items.map((item) => [
  item.equipmentName || '-',
  item.actionText || '-',
  item.category || '-',
  item.type || '-',
  item.priority ?? '-',
  item.status || '-',
  item.completed ? 'Yes' : 'No',
  formatActionItemDate(item.dueDate),
]);
